<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-4"
                />
            </b-col>
        </b-row>
        <div v-else>
            <b-row>
                <b-col>
                    <component-header
                        ref="headerComp"
                        title="Tenants"
                        @onClickSearch="searchSuggestions"
                        :enableOnClickSearch="true"
                        @select-query="selectPartnerType"
                        :selectedOption="selectedOption"
                        :isLoading="loading"
                        @reload-data="reloadData"
                        @create-press="$router.push({ path: '/tenant/create' })"
                        createButtonText="Create Tenant"
                        :hasCreate="true"
                        :hasback="false"
                        :hasDropdown="true"
                        :hasfilterOptions="searchType"
                    />
                </b-col>
            </b-row>
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        class="mt-3 rounded-card"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :items="tenants"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        thead-class="header"
                        :busy="loading"
                        show-empty
                        :fields="tenantColumns"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(userName)" slot-scope="data">
                            <div class="table-row">{{ data.item.userName }}</div>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <div class="inline_btnTable">
                                <ActionButtonGroup
                                    showView
                                    showEdit
                                    @view="ViewTenant(data.item)"
                                    @edit="editTenant(data.item)"
                                />
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-if="tenants.length > perPage"
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="tenants && tenants.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                        class="justify-content-center justify-content-md-end"
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import ebButton from "@/components/FormElements/Button";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import ebSelect from "@/components/FormElements/Select.vue";
import { AtomSpinner } from "epic-spinners";
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "Tenant",
    components: {
        ebButton,
        VueSimpleSuggest,
        ebSelect,
        ComponentHeader,
        AtomSpinner,
        ActionButtonGroup,
    },
    data() {
        return {
            tenantList: [],
            loading: false,
            selectedType: null,
            selectedOption: "",
            searchType: [
                {
                    text: "Select Search Type",
                    value: "",
                    disabled: true,
                },
                {
                    text: "Search by ID",
                    value: "id",
                },
                {
                    text: "Search by Email",
                    value: "email",
                },
                {
                    text: "Search by User Name",
                    value: "userName",
                },
            ],
            searchText: "",
            filter: "",
            perPage: 10,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            fixed: false,
            currentPage: 1,
            loading: true,
            context: "Add",
            tenant: {},
            tenantColumns: [
                {
                    key: "_id",
                    label: "ID",
                    sortable: true,
                },
                {
                    key: "userName",
                    sortable: true,
                },
                {
                    key: "email",
                },
                {
                    key: "status",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            allTenantsList: (state) => state.tenant.tenantsList,
        }),
        tenants() {
            let tenantItems = [];
            const raw = this.allTenantsList;
            const data = Array.isArray(raw)
                ? raw
                : (raw && raw.response) || (raw && raw.data) || [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    let arrayObj = {
                        _id: obj._id,
                        userName: obj.authentication?.userName || "",
                        email: obj.authentication?.email || "",
                        phone: obj.authentication?.phone || "",
                        password: "",
                        status: obj?.status || "",
                        ...obj,
                    };
                    tenantItems.push(arrayObj);
                });
            }
            return tenantItems;
        },
    },
    methods: {
        async searchSuggestions(val) {
            // If search is empty, reload all tenants
            if (!val || !val.trim()) {
                this.currentPage = 1;
                try {
                    await this.$store.dispatch("tenant/fetchTenantsList");
                } catch (e) {
                    this.$swal({
                        title: "Error",
                        text: "Failed to reload tenants",
                        type: "error",
                    });
                }
                return;
            }

            // Validate that search type is selected
            if (!this.selectedOption || this.selectedOption === "") {
                this.$swal({
                    title: "Error",
                    text: "Select search by Type!",
                    type: "error",
                });
                return;
            }

            // Validate email format if searching by email
            if (this.selectedOption === "email") {
                let validMail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
                if (!validMail) {
                    this.$swal({
                        title: "Error",
                        text: "Please enter a valid email address",
                        type: "error",
                    });
                    return;
                }
            }

            try {
                const payload = {
                    type: this.selectedOption,
                    data: val.trim(),
                };
                await this.$store.dispatch("tenant/filterListTenant", payload);
                // Reset to first page when filtering
                this.currentPage = 1;
                
                // Check if search returned no results
                this.$nextTick(() => {
                    if (!this.tenants || this.tenants.length === 0) {
                        this.$swal({
                            title: "No Results Found",
                            text: `No tenants found matching your search criteria for ${this.selectedOption}.`,
                            type: "info",
                        });
                    }
                });
            } catch (e) {
                this.$swal({
                    title: "Error",
                    text: e?.message || "Failed to filter tenants",
                    type: "error",
                });
            }
        },
        selectPartnerType(val) {
            this.selectedOption = val;
        },
        editTenant(data) {
            this.$router.push({
                name: "editTenant",
                params: { id: data._id, userData: data },
            });
        },
        ViewTenant(data) {
            this.$router.push({
                name: "viewTenant",
                params: { id: data._id, userData: data },
            });
        },
        // async deleteTenant(data) {
        //     this.$swal({
        //         title: "Delete this Tenant?",
        //         text: "Are you sure? You won't be able to revert this!",
        //         type: "warning",
        //         showCancelButton: true,
        //         confirmButtonColor: "#3085d6",
        //         confirmButtonText: "Yes, Delete it!",
        //     }).then((result) => {
        //         if (result.value) {
        //             this.$store.dispatch().then((result) => {
        //                 this.$toasted.success("Tenant Deleted Successfully");
        //                 this.$store
        //                     .dispatch("tenant/fetchTenantsList")
        //                     .catch((error) => {
        //                         this.$toasted.error(error.message);
        //                     });
        //             });
        //         }
        //     });
        //     this.$store.dispatch(
        //         "tenant/fetchTenantsList",
        //         this.$store.getters["auth/getUserID"],
        //     );
        // },
        async reloadData() {
            this.loading = true;
            // Reset search and filter state
            this.selectedOption = "";
            this.currentPage = 1;
            // Reset search string in header component if it exists
            if (this.$refs["headerComp"]) {
                this.$refs["headerComp"].resetSearchString();
            }
            try {
                await this.$store.dispatch("tenant/fetchTenantsList");
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: error?.message || "Failed to fetch data",
                    type: "error",
                });
            } finally {
                this.loading = false;
            }
        },
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch("tenant/fetchTenantsList");
        this.loading = false;
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
</style>
<style>
.rounded-card {
  border-radius: 12px;
}

.btn-warning {
  background: #fe7b08 !important;
  border-color: #fe7b08 !important;
}
.select-type {
    height: 39px !important;
    padding-top: 5px;
    /* width: 110% !important; */
    /* margin-left: 78px; */
}

.icon-btn {
    border-radius: 50%;
    color: white;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
}

.center {
    margin-left: 36% !important;
    width: 50%;
    padding: 10px;
}

.refresh-button {
    position: absolute;
    font-size: large;
    z-index: 1;
    right: 20px;
    width: 40px;
    height: 35px;
    padding: 0;
    top: 0px;
}

.create-btn {
    height: 36px;
    width: 150px;
    margin-left: 28px;
}

.vue-simple-suggest.designed .input-wrapper input {
    border-radius: 20px !important;
    height: 39px !important;
}

/* 
.form-control {
  height: 39px;
  margin-top: -24px;
} */

.text-grey {
    color: #aaa;
    background-color: transparent;
}

.vue-simple-suggest.designed .input-wrapper input {
    border-radius: 20px !important;
    height: 39px !important;
    /* margin-left: 77px !important; */
    width: 88% !important;
}
.card {
    margin-top: 0px !important;
}
.inline_btnTable {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
}

.inline_btnTable .btn {
  flex-shrink: 0;
  min-width: 30px;
  min-height: 30px;
}
</style>
